export default "__VITE_ASSET__65f7fe26__"